import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiExternalLink, FiClock, FiTag, FiActivity } = FiIcons;

const AssetCard = ({ asset, category, onClick }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'warning':
        return 'bg-yellow-100 text-yellow-800';
      case 'error':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getProviderIcon = (provider) => {
    // In a real app, you'd have specific icons for each provider
    return FiActivity;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-all duration-200 card-hover">
      <div className="p-6">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{asset.title}</h3>
            <p className="text-sm text-gray-600 line-clamp-2">{asset.description}</p>
          </div>
          <div className="ml-4 flex items-center space-x-2">
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(asset.status)}`}>
              {asset.status}
            </span>
          </div>
        </div>

        {/* Provider and category */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2 text-sm text-gray-500">
            <SafeIcon icon={getProviderIcon(asset.provider)} className="h-4 w-4" />
            <span>{asset.provider}</span>
          </div>
          {category && (
            <div className="flex items-center space-x-1 text-sm">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: category.color }}
              />
              <span className="text-gray-600">{category.name}</span>
            </div>
          )}
        </div>

        {/* Tags */}
        {asset.tags && asset.tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {asset.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-gray-100 text-gray-700"
              >
                <SafeIcon icon={FiTag} className="h-3 w-3 mr-1" />
                {tag}
              </span>
            ))}
            {asset.tags.length > 3 && (
              <span className="text-xs text-gray-500">+{asset.tags.length - 3} more</span>
            )}
          </div>
        )}

        {/* Footer */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-1 text-xs text-gray-500">
            <SafeIcon icon={FiClock} className="h-3 w-3" />
            <span>Updated {formatDistanceToNow(new Date(asset.lastChecked), { addSuffix: true })}</span>
          </div>
          <button
            onClick={onClick}
            className="inline-flex items-center space-x-1 px-3 py-1.5 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-700 transition-colors focus-ring"
          >
            <span>Open</span>
            <SafeIcon icon={FiExternalLink} className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssetCard;